function useCountryByLang(langCode) {
  const countryLangs = {
    en: "gb"
  };
  return countryLangs[langCode] ?? langCode;
}
var useCountryByLang_default = useCountryByLang;
export {
  useCountryByLang_default as default
};
